"use client";

import { Container, Stack, Title, Text } from "@forestsync/ui";
import { GlassroomTabs, LedgerStats } from "@/components/glassroom";

interface GlassroomPageClientProps {
  title: string;
  description: string;
  stats: any;
  carbonSinks: any[];
  projectDevelopers: any[];
  beneficiaries: any[];
}

export default function GlassroomPageClient({
  title,
  description,
  stats,
  carbonSinks,
  projectDevelopers,
  beneficiaries,
}: GlassroomPageClientProps) {
  return (
    <Container size="xl" className="h-full">
      <Stack gap="lg" py="md">
        {/* Header */}
        <div className="text-center">
          <Title
            order={1}
            size="h2"
            className="text-gray-900 dark:text-white mb-2"
          >
            {title}
          </Title>
          <Text
            size="lg"
            className="text-gray-600 dark:text-gray-300 max-w-3xl mx-auto"
          >
            {description}
          </Text>
        </div>

        {/* Statistics Overview */}
        <LedgerStats stats={stats} />

        {/* Main Content Tabs */}
        <GlassroomTabs
          carbonSinks={carbonSinks}
          projectDevelopers={projectDevelopers}
          beneficiaries={beneficiaries}
        />
      </Stack>
    </Container>
  );
}
